<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="row r2">
    <!-- Left Sidebar -->
    <div class="sidebar" [class.collapsed]="isSidebarCollapsed">
      <app-watchlist-sidetab
        [watchlists]="userWatchlists"
        [benchmarks]="benchmarks"
        [isLoading]="isLoading || isLoadingBenchmarks"
        (createWatchlist)="onCreateWatchlist()"
        (editWatchlist)="onEditWatchlist($event)"
        (deleteWatchlist)="onDeleteWatchlist($event)"
        (sectionChanged)="onSectionChanged($event)"
        (sidebarCollapsed)="onSidebarCollapsed($event)">
      </app-watchlist-sidetab>
    </div>

    <!-- Main Content Area -->
    <div class="main-content" [class.expanded]="isSidebarCollapsed">
      <app-watchlist-main-page
        [userWatchlists]="userWatchlists"
        [benchmarks]="benchmarks"
        (watchlistUpdated)="onWatchlistUpdated()"
        (createWatchlist)="onCreateWatchlist()"
        (editWatchlist)="onEditWatchlist($event)">
      </app-watchlist-main-page>
    </div>
  </div>
</div>